import {Divider, Input, message, Radio} from "antd";
import {useState} from "react";

export const TakePassword = ({setStep, otp}) => {
    const [otpValue, setOtpValue] = useState('');


    const sendOtp = () => {
        message.success("Mã xác nhận đã được gửi",0.8);
    }

    const handleConfirm = () => {
        if(otpValue !== otp){
            message.error("Mã xác nhận không đúng");
            return;
        }
        message.success("Xác nhận thành công");
        setStep(3);
    }
    return (
        <div className={"space-y-3"}>
            <div className={"space-y-3"}>
                <Divider className={"text-gray-500"}>Chọn phương thức đổi mật khẩu</Divider>
                <Radio.Group className={"space-y-2 flex border rounded-md p-4 flex-col"}>
                    <Radio value={1}>Gửi mã qua email</Radio>
                    <Radio value={2}>Gửi mã qua SMS</Radio>
                    <Radio value={3}>Gủi mã qua Zalo</Radio>
                </Radio.Group>
                <div className={"flex flex-1 justify-center"}>
                    <button
                        onClick={sendOtp}
                        className="px-6 py-2 w-full bg-green-500 text-white rounded-md font-semibold hover:bg-green-800">
                        Gửi mã xác nhận
                    </button>
                </div>
            </div>
            <div className={"space-y-3 rounded-md p-4 border"}>
                <Divider className={"text-gray-500"}>Nhập mã xác nhận</Divider>
                <div className={"space-y-2"}>
                    <label className={"block text-sm font-medium"}>Mã xác nhận<span className={"text-red-500"}>*</span></label>
                    <Input onChange={(e) => setOtpValue(e.target.value)} type="text" className={"w-full p-2 border rounded-md"} placeholder="Nhập mã xác nhận"/>
                </div>
                <div className={"flex justify-center"}>
                    <button
                        onClick={handleConfirm}
                        className="px-6 py-2 w-1/2 bg-black text-white rounded-md font-semibold hover:bg-gray-800">
                        Xác nhận
                    </button>
                </div>
            </div>
        </div>
    )
}